import { useState, useEffect } from 'react';
import {
  getAdminStats,
  getAdminDailyReport,
  getRecentActivities,
  getTopRestaurants,
  getTopUsers,
} from '../services/adminApi';

export const useAdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalRestaurants: 0,
    totalOrders: 0,
    totalRevenue: 0,
    pendingRestaurants: 0,
    activeUsers: 0,
    monthlyGrowth: 0,
    weeklyOrders: 0
  });

  const [recentActivities, setRecentActivities] = useState([]);
  const [topRestaurants, setTopRestaurants] = useState([]);
  const [topUsers, setTopUsers] = useState([]);
  const [dailyReport, setDailyReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [
        statsData,
        activitiesData,
        restaurantsData,
        usersData,
        dailyData,
      ] = await Promise.all([
        getAdminStats(),
        getRecentActivities(),
        getTopRestaurants(),
        getTopUsers(),
        getAdminDailyReport(14).catch(() => null),
      ]);

      const users = statsData.users || {};
      const restaurants = statsData.restaurants || {};
      const orders = statsData.orders || {};
      const revenue = statsData.revenue || {};
      setStats({
        totalUsers: users.total ?? 0,
        totalRestaurants: restaurants.total ?? 0,
        totalOrders: orders.total ?? 0,
        totalRevenue: revenue.total ?? 0,
        pendingRestaurants: restaurants.inactive ?? 0,
        activeUsers: users.active ?? users.total ?? 0,
        monthlyGrowth: 0,
        weeklyOrders: 0
      });

      setRecentActivities(Array.isArray(activitiesData) ? activitiesData : []);
      setTopRestaurants(Array.isArray(restaurantsData) ? restaurantsData : []);
      setTopUsers(Array.isArray(usersData) ? usersData : []);
      setDailyReport(dailyData && typeof dailyData === 'object' ? dailyData : null);

    } catch (err) {
      console.error('Erreur chargement dashboard admin:', err);

      // Gestion spécifique des erreurs
      if (err.message?.includes('401') || err.message?.includes('Unauthorized')) {
        setError('Session expirée - veuillez vous reconnecter');
      } else {
        setError(err.message || 'Erreur lors du chargement des données');
      }

      setStats({
        totalUsers: 0,
        totalRestaurants: 0,
        totalOrders: 0,
        totalRevenue: 0,
        pendingRestaurants: 0,
        activeUsers: 0,
        monthlyGrowth: 0,
        weeklyOrders: 0
      });
      setRecentActivities([]);
      setTopRestaurants([]);
      setTopUsers([]);
      setDailyReport(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  return {
    stats,
    recentActivities,
    topRestaurants,
    topUsers,
    dailyReport,
    loading,
    error,
    refetch: fetchDashboardData
  };
};





